module.exports = __webpack_public_path__ + "media/img/frontend_application/banner-miceneurol-eed25b32d93ce4c16b6d5d9cc11cee2e.png";